import React, { Suspense, lazy, useRef } from 'react';
import { autobind } from 'core-decorators';
import moment from 'moment';
import qs from 'query-string';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col } from 'src/componentes/grid';
import HoverCard from 'src/componentes/hover-card';
import { cn } from 'cn';

import http from 'src/services/httpService';
import Edit from 'src/componentes/edit/edit-dialog';
import Input from 'src/componentes/input';
import InputGroup from 'src/componentes/input-group';
import InputNumber from 'src/componentes/input-number';
import StatusAcaoLookup from 'src/lookups/status-acao';
import DatePicker from 'src/componentes/date-picker';
import SvgIcon from 'src/componentes/svg-icon';
import LucideIcon from 'src/componentes/lucide-icon';
import errorHandler from 'src/utils/error-handler';
import AcaoLookup from 'src/lookups/acao';
import { capitalizeFirstLetter } from 'src/utils/string';
import Checkbox from 'src/componentes/checkbox';
import ContentManager from 'src/componentes/content-manager';
import Confirm from 'src/componentes/message-box/confirm';
import Alert from 'src/componentes/message-box/alert';
import GanhosPorAcaoEdit from './ganhos-por-acao/edit';
import ItemLookup from 'src/lookups/item';
import DropDownItem from 'src/paginas/item/dropdown';
import CentroCustoLookup from 'src/lookups/item-centro-custo';
import PacoteLookup from 'src/lookups/pacote';
import InlineChecklist from 'src/componentes/checklist/InlineChecklist';
import formatarData from 'src/utils/formatarData';
import css from 'src/utils/css';
import { setGanhosPorAcao } from 'src/actions/ganhos-por-acao';
import ArquivoUploadAnexos from 'src/componentes/arquivo-upload/anexos';
import ResponsiveList from 'src/componentes/list/responsive-list';
import Info from 'src/componentes/info';
import LoadingScreen from 'src/componentes/LoadingScreen';
import {
  MODULOS,
  STATUS_ACAO,
  TIPO_ITENS,
  TIPO_ORIGEM,
  STATUS_ITEM,
} from 'src/utils/constants';
import TagLookup from 'src/lookups/TagLookup';
import TipoAcaoLookup from 'src/lookups/tipo-acao';
import ColaboradorLookup from 'src/lookups/colaborador-lookup';
import ResponsavelButtonLookup from 'src/lookups/colaborador-button';
import Tabs from 'src/componentes/tabs/tabs';
import Tab from 'src/componentes/tabs/tab';
import ModalFormCategoryLayout from 'src/componentes/modal-form-layout/ModalFormCategoryLayout';
import ModalFormCategoryBadge from 'src/componentes/modal-form-layout/ModalFormCategoryBadge';
import useCollapsesScrollHeight from 'src/componentes/modal-form-layout/useCollapsesScrollHeight';
import StatusBadge from 'src/componentes/StatusBadge';
import './acao-resumo-tooltip.css';
import ComentarioButton from 'src/componentes/comentarios/ComentarioButton';
import {
  buildComentarioDialogTitle,
  extractPeriodoDescricao,
} from 'src/componentes/comentarios/utils';

import PercentualAvancoFisicoList from './componentes/PercentualAvancoFisicoList';
import VincularAcaoForm, {
  TipoCadastroAcaoRow,
} from './componentes/VincularAcaoForm';
import DetalhamentoInvestimentoCusteioModal from 'src/paginas/item/edit/resumo/DetalhamentoInvestimentoCusteioModal';
import schema from './schema';

const ItemLink = lazy(() => import('../item/link'));
const Historico = lazy(() => import('../versao-alteracao'));
const TabelaRelacionamento = lazy(() => import('../item/relacionamento'));
const ValidacaoRestricao = lazy(() => import('../item/validacao-restricao'));
const DesenharCampoCustomizado = lazy(() =>
  import('../item/campo-customizado/componentes/desenhar')
);
const IdIntegracaoAcaoVinculada = lazy(() =>
  import('./componentes/id-acao-vinculada')
);
const AlocacaoRecursos = lazy(() =>
  import('src/paginas/EscritorioProjetos/alocacaorecursos').then((m) => ({
    default: m.AlocacaoRecursosBase,
  }))
);
const HistoricoAcaoTarefa = lazy(() => import('../acao/Tarefas/historico'));

const classes = css`
  .inputText {
    margin-left: 20px;
    min-width: 75px;
    max-width: 125px;
  }

  .descricaoHeaderRow {
    margin-bottom: 0.75rem;
    min-width: 0;
  }

  .descricaoHeaderMain {
    min-width: 0;
  }

  .descricaoHeaderContent {
    display: flex;
    align-items: baseline;
    min-width: 0;
    gap: 0.75rem;
  }

  .descricaoHeaderTexto {
    flex: 0 1 auto;
    min-width: 0;
    color: #09090b;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .descricaoResumoLink {
    color: #1d7789;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .anexosComentariosRow {
    display: flex;
    align-items: center;
    gap: 18px;
    flex-wrap: wrap;
    margin-bottom: 1rem;
  }

  .anexosInline {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  .anexosInlineLabel {
    color: #71717a;
    font-size: 14px;
    font-weight: 600;
  }

  .aprovarCadastroField {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 38px;
    padding: 12px 16px;
    border: none;
    border-radius: 8px;
    background: #f4f4f5;
    margin-bottom: 1rem;
    box-sizing: border-box;
  }

  .infoBasicaEdicaoLinha1 {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .infoBasicaEdicaoItem {
    flex: 0 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .infoBasicaEdicaoItemValor {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .infoBasicaEdicaoItemValor a {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
  }

  .infoBasicaEdicaoMeta {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 0.75rem;
  }
`;

const AC_CAT_DADOS = 'acao-cat-dados';
const AC_CAT_INFO_BASICA = 'acao-cat-info-basica';
const AC_CAT_CRONOGRAMA = 'acao-cat-cronograma';
const AC_CAT_RISCO = 'acao-cat-risco';
const AC_CAT_5W2H = 'acao-cat-5w2h';
const AC_CAT_CUSTOS = 'acao-cat-custos';
const AC_CAT_CHECKLIST = 'acao-cat-checklist';

const AC_SEC_INFO_BASICA = 'acao-sec-info-basica';
const AC_SEC_CRONOGRAMA = 'acao-sec-cronograma';
const AC_SEC_RISCO = 'acao-sec-risco';
const AC_SEC_5W2H = 'acao-sec-5w2h';
const AC_SEC_CUSTOS = 'acao-sec-custos';
const AC_SEC_CHECKLIST = 'acao-sec-checklist';

function getChecklistNavBadge(concluidas, total) {
  const text = `${concluidas}/${total}`;

  if (total === 0 || concluidas === 0) {
    return { text, variant: 'default' };
  }

  if (concluidas >= total) {
    return { text, variant: 'done' };
  }

  return { text, variant: 'doing' };
}

function disabledDate(current) {
  if (!current) {
    // allow empty select
    return false;
  }
  const date = moment();
  date.hour(23);
  date.minute(59);
  date.second(59);
  return current.valueOf() > date.valueOf(); // não pode selecionar data realizada depois da data atual
}

@autobind
class FormEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFieldDate: [
        'dataInicioPrevista',
        'dataTerminoPrevista',
        'dataInicioRealizada',
        'dataTerminoRealizada',
      ],
      configuracoes: [],
      itemId: window.location && qs.parse(window.location.search).itemId,
      centroCustoId:
        window.location && qs.parse(window.location.search).centroCustoId,
      pacoteId: window.location && qs.parse(window.location.search).pacoteId,
      editarDemaisCampos: this.fillEditarDemaisCampos(),
      editarDataPrevista: this.fillEditarDataPrevista(),
      editarDataRealizadaPercentualObservacao:
        this.fillEditarDataRealizadaPercentualObservacao(),
      editarAcaoOrigem: true,
      camposDesabilitados: false,
      disableVincularAcao: false,
      editarEsforco: this.fillEditarDemaisCampos(), //Campo esforço faz parte de "editarDemaisCampos", mas ações vinculadas podem alterar o esforço
      paiAlterado:
        this.props.paiAlterado != null ? this.props.paiAlterado : false,
      permissoesAcaoValor: {
        allowView: false,
        podeEditarMeta: false,
        podeEditarRealizado: false,
      },
      isLoadingHintAcao: false,
      acaoHintId: 0,
      arvoreHintAcao: null,
      historicoRefreshToken: 0,
      resumoPopoverOpen: false,
      utilizarAlocacaoRecursos: false,
      diasDecorridos: 0,
    };

    this.alocacaoSaveApi = null;

    this.resumoPopoverHoverReady = false;
    this.resumoPopoverHoverReadyTimer = setTimeout(() => {
      this.resumoPopoverHoverReady = true;
    }, 350);

    http.get(`/AcaoConfiguracao/ObterConfiguracoes`).then((response) => {
      this.setState({
        configuracoes: response?.data,
      });
    });

    http
      .post(`/ItemConfiguracaoProjeto/ObterConfiguracoes`, {})
      .then((response) => {
        this.setState({
          utilizarAlocacaoRecursos:
            response?.data?.utilizarAlocacaoRecursos || false,
        });
      })
      .catch(() => {});

    http
      .get(`/AcaoValor/ObterPermissoesAcaoValorPorId`)
      .then((response) => {
        if (response.data != null) {
          this.setState({
            permissoesAcaoValor: { ...response.data },
          });
        }
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  obterTimestampData(date) {
    return date ? new Date(date).getTime() : null;
  }

  atualizarDiasDecorridos(dataInicioPrevista) {
    if (dataInicioPrevista) {
      this.obterDuracao(dataInicioPrevista, new Date(), (duracao) => {
        this.setState({
          diasDecorridos: duracao || 0,
        });
      });
    } else {
      this.setState({
        diasDecorridos: 0,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const dataInicioPrevista = this.props.model.value?.dataInicioPrevista;
    const prevDataInicioPrevista = prevProps.model.value?.dataInicioPrevista;

    if (
      this.obterTimestampData(dataInicioPrevista) !==
      this.obterTimestampData(prevDataInicioPrevista)
    ) {
      this.atualizarDiasDecorridos(dataInicioPrevista);
    }
  }

  handleSelectDate(fieldName) {
    this.setState(() => ({
      selectedFieldDate: this.state.selectedFieldDate.filter(
        (item) => item !== fieldName
      ),
    }));
  }

  fillPontosProblematicos() {
    let ponto = [];
    if (
      this.props.pontosProblematicos &&
      (!this.props.model.getModel('pontosProblematicos').value ||
        this.props.model.getModel('pontosProblematicos').value.length == 0)
    ) {
      ponto.push(this.props.pontosProblematicos[0]);
      this.props.model.getModel('pontosProblematicos').requestChange(ponto);
    } else if (
      !this.props.pontosProblematicos &&
      ponto.push(this.props.model.getModel('causasImpactadas').value)
    ) {
      //ponto.push(this.props.model.getModel('causasImpactadas').value)
      //this.props.model.getModel('pontosProblematicos').requestChange(ponto);
    }
  }

  fillEditarDemaisCampos() {
    let detail = this.props.mode ? this.props.mode === 'detail' : true;
    let editarDemaisCampos = detail
      ? true
      : this.props.model.getModel('editarDemaisCampos').value;
    return editarDemaisCampos;
  }

  fillEditarDataPrevista() {
    let detail = this.props.mode ? this.props.mode === 'detail' : true;
    let editarDataPrevista = detail
      ? true
      : this.props.model.getModel('editarDataPrevista').value;
    return editarDataPrevista;
  }

  fillEditarDataRealizadaPercentualObservacao() {
    let detail = this.props.mode ? this.props.mode === 'detail' : true;
    let editarDataRealizadaPercentualObservacao = detail
      ? true
      : this.props.model.getModel('editarDataRealizadaPercentualObservacao')
          .value;
    return editarDataRealizadaPercentualObservacao;
  }

  handleEdit() {
    this.props.onChangeMode && this.props.onChangeMode('edit');
  }

  handleClose() {
    this.props.onRequestClose && this.props.onRequestClose();
  }

  addDay(date, days) {
    let newDate = new Date(date.getTime());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  }

  handleChangeDataInicioPrevista(value) {
    this.props.model.getModel('dataPrevistaAlterada').requestChange(true);
    this.props.model.getModel('dataInicioPrevista').requestChange(value);
    let itemId =
      this.props.model.getModel('item').value &&
      this.props.model.getModel('item').value.id;

    if (
      this.props.model.getModel('dataTerminoPrevista').value == null &&
      value != null
    ) {
      this.props.model
        .getModel('dataTerminoPrevista')
        .requestChange(this.addDay(value, 1));
    }

    if (value != null) {
      http
        .post(`/Acao/ObterDataTermino`, {
          itemId: itemId,
          duracao: this.props.model.getModel('duracao').value,
          dataInicio: value,
        })
        .then((response) => {
          this.props.model
            .getModel('dataTerminoPrevista')
            .requestChange(response.data);
        })
        .catch((error) => {
          errorHandler(error);
        });
    }

    this.atualizarDiasDecorridos(value);
  }

  handleChangeDataTerminoPrevisto(value) {
    this.props.model.getModel('dataPrevistaAlterada').requestChange(true);
    this.props.model.getModel('dataTerminoPrevista').requestChange(value);

    if (
      this.props.model.getModel('dataInicioPrevista').value == null &&
      value != null
    ) {
      this.props.model
        .getModel('dataInicioPrevista')
        .requestChange(this.addDay(value, -1));
    }

    this.obterDuracao(
      this.props.model.getModel('dataInicioPrevista').value,
      value,
      (duracao) => {
        this.props.model.getModel('duracao').requestChange(duracao);
      }
    );
  }

  handleChangeDuracao(value) {
    if (value < 0) value = 0;

    this.props.model.getModel('duracao').requestChange(value);
    let itemId =
      this.props.model.getModel('item').value &&
      this.props.model.getModel('item').value.id;
    if (value >= 0 && this.props.model.getModel('dataInicioPrevista').value) {
      this.props.model.getModel('dataPrevistaAlterada').requestChange(true);

      http
        .post(`/Acao/ObterDataTermino`, {
          itemId: itemId,
          duracao: value,
          dataInicio: this.props.model.getModel('dataInicioPrevista').value,
        })
        .then((response) => {
          this.props.model
            .getModel('dataTerminoPrevista')
            .requestChange(response.data);
        })
        .catch((error) => {
          errorHandler(error);
        });
    }
  }

  handleChangedataInicioRealizada(value) {
    this.props.model.getModel('dataInicioRealizada').requestChange(value);
    if (!value) {
      this.props.model.getModel('percentualRealizado').requestChange(null);
    }
  }

  handleChangePercentualRealizado(value) {
    this.props.model.getModel('percentualRealizado').requestChange(value);
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  obterDuracao(dataInicio, dataTermino, onSuccess) {
    if (!dataInicio) {
      return;
    }
    http
      .post(`/Acao/ObterDuracao`, {
        itemId: this.props.model.getModel('item').value?.id,
        dataInicio: dataInicio,
        dataTermino: dataTermino,
      })
      .then((response) => {
        if (onSuccess) {
          onSuccess(response.data);
        }
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  handleTipoCadastroAcaoChange(tipoId) {
    const utilizarVinculada = tipoId === 'vincular';
    if (
      this.props.model.getModel('utilizarAcaoVinculada').value ===
      utilizarVinculada
    ) {
      return;
    }

    this.props.model
      .getModel('utilizarAcaoVinculada')
      .requestChange(utilizarVinculada);

    const podeEditar = !utilizarVinculada;
    this.setState({
      editarDemaisCampos: podeEditar,
      editarDataPrevista: podeEditar,
      editarDataRealizadaPercentualObservacao: podeEditar,
    });
  }

  confirmarAcaoVinculada(acaoVinculada, itemId) {
    if (acaoVinculada) {
      ContentManager.addContent(
        <Confirm
          message={this.props.intl.formatMessage(
            { id: 'label.desejaVincularEstaAcao' },
            { acao: this.props.resources.acao }
          )}
          handleConfirm={this.handleVincularAcaoConfirm.bind(
            this,
            acaoVinculada,
            itemId
          )}
        />
      );
    } else {
      ContentManager.addContent(
        <Alert
          title={this.props.intl.formatMessage({ id: 'alerta' })}
          message={this.props.intl.formatMessage(
            { id: 'label.selecioneAcaoOrigem' },
            { acao: this.props.resources.acao }
          )}
        />
      );
    }
  }

  handleCloseEdit() {
    this.props.handleClose && this.props.handleClose(true);
    this.props.handleCloseEdit && this.props.handleCloseEdit();
  }

  handleVincularAcaoConfirm(acaoVinculada, itemId) {
    let relatorioId = this.props.parameters
      ? this.props.parameters.relatorioId
      : 0;
    const eventoRiscoId = this.props.parameters?.eventoRiscoId;
    const entidadeId = this.props.parameters?.entidadeId;
    const tipoOrigemId = this.props.parameters?.tipoOrigemId;
    let { configuracoes } = this.state;
    if (configuracoes.model.utilizarCodigoAutomatico === false) {
      ContentManager.addContent(
        <IdIntegracaoAcaoVinculada
          model={this.props.model}
          acaoOrigemId={acaoVinculada.id}
          itemId={itemId}
          auditoriaId={this.props.model?.getModel('auditoriaRisco')?.value?.id}
          controlSelfAssessmentId={
            this.props.model?.getModel('controlSelfAssessment')?.value?.id
          }
          pontoControleId={
            this.props.model?.getModel('pontoDeControle')?.value?.id
          }
          perdaOperacionalId={
            this.props.model?.getModel('perdaOperacional')?.value?.id
          }
          testeControleId={
            this.props.model?.getModel('testeControle')?.value?.id
          }
          eventoRiscoId={eventoRiscoId}
          entidadeId={entidadeId}
          tipoOrigemId={tipoOrigemId}
          relatorioId={relatorioId}
          closeEdit={this.handleCloseEdit}
          onVincularAcaoSuccess={this.props.onVincularAcaoSuccess}
        />
      );
    } else {
      http
        .post(`/Acao/VincularAcao`, {
          acaoOrigemId: acaoVinculada.id,
          itemId: itemId,
          relatorioId: relatorioId,
          auditoriaId: this.props.model?.getModel('auditoriaRisco')?.value?.id,
          controlSelfAssessmentId: this.props.model?.getModel(
            'controlSelfAssessment'
          )?.value?.id,
          pontoControleId:
            this.props.model?.getModel('pontoDeControle')?.value?.id,
          perdaOperacionalId:
            this.props.model?.getModel('perdaOperacional')?.value?.id,
          elementoId: this.props?.parameters?.elementoId ?? null,
          testeControleId:
            this.props.model?.getModel('testeControle')?.value?.id,
          eventoRiscoId: eventoRiscoId,
          entidadeId: entidadeId,
          tipoOrigemId: tipoOrigemId,
        })
        .then((response) => {
          this.props.onVincularAcaoSuccess &&
            this.props.onVincularAcaoSuccess(response?.data);
          this.handleCloseEdit();
        })
        .catch((error) => {
          errorHandler(error);
        });
    }
  }

  validaSeNaoPodeAdicionarCausa(pontosProblematicos) {
    return (pontosProblematicos || []).some(
      (ponto) => ponto.ehPontoProblematicoDaAcao
    );
  }

  handleResumoPopoverOpenChange(open) {
    if (open && !this.resumoPopoverHoverReady) return;

    this.setState({ resumoPopoverOpen: open });
  }

  componentWillUnmount() {
    if (this.resumoPopoverHoverReadyTimer) {
      clearTimeout(this.resumoPopoverHoverReadyTimer);
    }
  }

  renderAcaoResumoTooltipContent({
    intl,
    resources,
    resumoItem,
    resumoDescricao,
    resumoStatus,
    tipoOrigemDescricao,
    resumoInicioPrevisto,
    resumoTerminoPrevisto,
    farolAcao,
  }) {
    const rows = [
      {
        label: capitalizeFirstLetter(intl.formatMessage({ id: 'item' })),
        value: resumoItem,
        ellipsis: true,
      },
      {
        label: capitalizeFirstLetter(
          intl.formatMessage(
            { id: 'descricaoDaAcao' },
            { acao: resources.acao }
          )
        ),
        value: resumoDescricao,
        ellipsis: true,
      },
      {
        label: capitalizeFirstLetter(intl.formatMessage({ id: 'status' })),
        value: resumoStatus,
      },
      {
        label: capitalizeFirstLetter(intl.formatMessage({ id: 'tipoOrigem' })),
        value: tipoOrigemDescricao,
        ellipsis: true,
      },
      {
        label: capitalizeFirstLetter(resources.farol),
        value: farolAcao?.icone ? (
          <SvgIcon
            icon={farolAcao.icone}
            size={12}
            color={farolAcao.cor}
            colorHover={farolAcao.cor}
            title={farolAcao.descricao}
          />
        ) : (
          '-'
        ),
        isFarol: true,
      },
      {
        label: capitalizeFirstLetter(
          intl.formatMessage({ id: 'dataInicioPrevista' })
        ),
        value: resumoInicioPrevisto,
      },
      {
        label: capitalizeFirstLetter(
          intl.formatMessage({ id: 'dataTerminoPrevista' })
        ),
        value: resumoTerminoPrevisto,
      },
    ];

    return (
      <div className="tw:grid tw:grid-cols-[auto_minmax(0,1fr)] tw:gap-x-4 tw:gap-y-2 tw:text-left">
        {rows.map((row) => (
          <React.Fragment key={row.label}>
            <span className="tw:text-[13px] tw:leading-[1.35] tw:font-semibold tw:whitespace-nowrap tw:text-white/78">
              {row.label}
            </span>
            {row.isFarol ? (
              <span className="tw:flex tw:min-w-0 tw:items-center">
                {row.value}
              </span>
            ) : (
              <span
                className={cn(
                  'tw:min-w-0 tw:text-[13px] tw:leading-[1.35] tw:font-semibold tw:text-white',
                  row.ellipsis && 'tw:truncate'
                )}
                title={
                  row.ellipsis && typeof row.value === 'string'
                    ? row.value
                    : undefined
                }
              >
                {row.value}
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  }

  alterarModelVinculada(modelOrigem) {
    let { model } = this.props;
    model.getModel('acaoOrigem').requestChange(modelOrigem.acaoOrigem);
    model
      .getModel('baselineInicial')
      .requestChange(modelOrigem.baselineInicial);
    model
      .getModel('baselineTermino')
      .requestChange(modelOrigem.baselineTermino);
    model
      .getModel('camposCustomizados')
      .requestChange(modelOrigem.camposCustomizados);
    model.getModel('centroCusto').requestChange(modelOrigem.centroCusto);
    model.getModel('codigo').requestChange(modelOrigem.codigo);
    model.getModel('como').requestChange(modelOrigem.como);
    model
      .getModel('custeioPrevisto')
      .requestChange(modelOrigem.custeioPrevisto);
    model
      .getModel('custeioRealizado')
      .requestChange(modelOrigem.custeioRealizado);
    model
      .getModel('dataInicioPrevista')
      .requestChange(modelOrigem.dataInicioPrevista);
    model
      .getModel('dataInicioRealizada')
      .requestChange(modelOrigem.dataInicioRealizada);
    model
      .getModel('dataTerminoPrevista')
      .requestChange(modelOrigem.dataTerminoPrevista);
    model
      .getModel('dataTerminoRealizada')
      .requestChange(modelOrigem.dataTerminoRealizada);
    model.getModel('descricao').requestChange(modelOrigem.descricao);
    model.getModel('duracao').requestChange(modelOrigem.duracao);
    model
      .getModel('editarDataPrevista')
      .requestChange(modelOrigem.editarDataPrevista);
    model
      .getModel('editarDataRealizadaPercentualObservacao')
      .requestChange(modelOrigem.editarDataRealizadaPercentualObservacao);
    model
      .getModel('editarDemaisCampos')
      .requestChange(modelOrigem.editarDemaisCampos);
    model
      .getModel('ehAcaoVinculada')
      .requestChange(modelOrigem.ehAcaoVinculada);
    model.getModel('esforco').requestChange(modelOrigem.esforco);
    model.getModel('farolAcao').requestChange(modelOrigem.farolAcao);
    model
      .getModel('farolInvestimento')
      .requestChange(modelOrigem.farolInvestimento);
    model.getModel('filhos').requestChange(modelOrigem.filhos);
    model.getModel('id').requestChange(modelOrigem.id);
    model
      .getModel('investimentoPrevisto')
      .requestChange(modelOrigem.investimentoPrevisto);
    model
      .getModel('investimentoRealizado')
      .requestChange(modelOrigem.investimentoRealizado);
    model.getModel('item').requestChange(modelOrigem.item);
    model.getModel('itemAcaoOrigem').requestChange(modelOrigem.itemAcaoOrigem);
    model
      .getModel('itensVinculados')
      .requestChange(modelOrigem.itensVinculados);
    model.getModel('observacao').requestChange(modelOrigem.observacao);
    model.getModel('onde').requestChange(modelOrigem.onde);
    model.getModel('pacote').requestChange(modelOrigem.pacote);
    model.getModel('pai').requestChange(modelOrigem.pai);
    model
      .getModel('percentualPrevisto')
      .requestChange(modelOrigem.percentualPrevisto);
    model
      .getModel('percentualRealizado')
      .requestChange(modelOrigem.percentualRealizado);
    model.getModel('permissions').requestChange(modelOrigem.permissions);
    model
      .getModel('podeEditarCusteioPrevisto')
      .requestChange(modelOrigem.podeEditarCusteioPrevisto);
    model
      .getModel('podeEditarCusteioRealizado')
      .requestChange(modelOrigem.podeEditarCusteioRealizado);
    model
      .getModel('podeEditarInvestimentoPrevisto')
      .requestChange(modelOrigem.podeEditarInvestimentoPrevisto);
    model
      .getModel('podeEditarInvestimentoRealizado')
      .requestChange(modelOrigem.podeEditarInvestimentoRealizado);
    model.getModel('porque').requestChange(modelOrigem.porque);
    model.getModel('predecessoras').requestChange(modelOrigem.predecessoras);
    model.getModel('responsavel').requestChange(modelOrigem.responsavel);
    model.getModel('status').requestChange(modelOrigem.status);
    model.getModel('utilizarAcaoVinculada').requestChange(true);
    model.getModel('tipoAcao').requestChange(modelOrigem.tipoAcao);
    model
      .getModel('descricaoMatrizRisco')
      .requestChange(modelOrigem.descricaoMatrizRisco);
    model
      .getModel('avaliacaoPendente')
      .requestChange(modelOrigem.avaliacaoPendente);
    model
      .getModel('descricaoGrauRisco')
      .requestChange(modelOrigem.descricaoGrauRisco);
    model.getModel('auditoriaRisco').requestChange(modelOrigem.auditoriaRisco);
    model
      .getModel('controlSelfAssessment')
      .requestChange(modelOrigem.controlSelfAssessment);
    model
      .getModel('pontoDeControle')
      .requestChange(modelOrigem.pontoDeControle);

    this.setState({
      editarAcaoOrigem: false,
    });
  }

  clickItemAcaoOrigem(item) {
    let { parameters } = this.props;
    http
      .post(`/Acao/TemPermissaoAcessarItemAcaoOrigem`, {
        itemId: item && item.id,
        acaoId: this.props.item && this.props.item.id,
      })
      .then((response) => {
        let temPermissao = response.data.temPermissao;
        let acaoOrigem = response.data.acaoOrigem;
        if (temPermissao) {
          this.props.handleCloseEdit && this.props.handleCloseEdit();
          ContentManager.addContent(
            <AcaoEdit
              item={acaoOrigem}
              handleClose={
                this.props.onRequestClose && this.props.onRequestClose
              }
              parameters={{
                itemId: acaoOrigem && acaoOrigem.item && acaoOrigem.item.id,
                centroCustoId: parameters && parameters.centroCustoId,
                pacoteId: parameters && parameters.pacoteId,
              }}
              resources={this.props.resources}
            ></AcaoEdit>
          );
        } else {
          ContentManager.addContent(
            <Alert
              title={this.props.intl.formatMessage({ id: 'erro' })}
              message={this.props.intl.formatMessage({
                id: 'label.voceNaoTemPermissaoParaVisualizarEstesRegistros',
              })}
            />
          );
        }
      });
  }

  handleChangeAcaoSuperior(value) {
    let model = this.props.model;
    model.getModel('pai').requestChange(value);

    if (this.props.item == null) {
      if (value != null) {
        this.setState(
          {
            paiAlterado: true,
          },
          () => {
            http
              .post(`/Acao/GerarCodigo`, {
                editModel: model.getModel().value,
                parameters: this.props.parameters,
                parentId: value.id,
              })
              .then((response) => {
                model.getModel('codigo').requestChange(response.data);
              });
          }
        );
      } else {
        this.setState({
          paiAlterado: false,
        });
      }
    }
  }

  afterSave() {
    this.props.handleRefresh && this.props.handleRefresh();
  }

  renderRadioButton() {
    const optionsRadio = [
      {
        id: 1,
        descricao: this.props.intl.formatMessage({ id: 'preventiva' }),
      },
      {
        id: 2,
        descricao: this.props.intl.formatMessage({ id: 'corretiva' }),
      },
    ];
    return optionsRadio;
  }

  async handleMouseOver(acao) {
    this.setState({
      isLoadingHintAcao: true,
      acaoHintId: acao.id,
    });

    try {
      var retorno = await http.post(`/Acao/ObterHintAcoes`, {
        itemNome: acao.nomeItem,
        acaoId: acao.id,
        acaoDescricao: acao.descricao,
      });

      this.setState({ arvoreHintAcao: retorno, isLoadingHintAcao: false });
    } catch (error) {
      errorHandler(error);
      this.setState({
        isLoadingHintAcao: false,
      });
    }
  }

  handleMouseOut() {
    this.setState({ acaoHintId: 0 });
  }

  registerAlocacaoSaveApi(api) {
    this.alocacaoSaveApi = api;
  }

  saveAlocacaoIfDirty() {
    if (this.alocacaoSaveApi?.saveIfDirty) {
      return this.alocacaoSaveApi.saveIfDirty();
    }
    return Promise.resolve();
  }

  renderCampoSomenteLeitura(label, value) {
    return (
      <div
        style={{
          minHeight: 24,
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'nowrap',
        }}
      >
        <b>{label} &nbsp;</b>
        {value ?? '-'}
      </div>
    );
  }

  renderTipoOrigemBadge(tipoOrigemDescricao) {
    return (
      <StatusBadge
        text={tipoOrigemDescricao || '-'}
        textColor="#71717A"
        backgroundColor="#F5F5F5"
      />
    );
  }

  renderCampoCodigoImportacao({
    model,
    bloquearCodigoAutomatico,
    editarDemaisCampos,
    paiAlterado,
  }) {
    return (
      <Row>
        <Col md={12}>
          <Input
            required
            disabled={
              bloquearCodigoAutomatico ||
              !editarDemaisCampos ||
              paiAlterado === true
            }
            model={model.getModel('codigo')}
          />
        </Col>
      </Row>
    );
  }

  renderItemPrincipalConteudo({
    model,
    ehControlSelfAssessment,
    ehAuditoria,
    ehControle,
    ehPerdaOperacional,
    ehPesquisaClima,
    ehOcorrencia,
    isAcaoPreAprovacaoCadastro,
    itemId,
  }) {
    if (model.getModel('auditoriaRiscoChecklistPergunta').value) {
      return model.getModel('auditoriaRiscoChecklistPergunta').value;
    }
    if (ehControlSelfAssessment && !isAcaoPreAprovacaoCadastro) {
      return model.getModel('controlSelfAssessment.nome').value;
    }
    if (ehAuditoria && !isAcaoPreAprovacaoCadastro) {
      return model.getModel('auditoriaRisco.nome').value;
    }
    if (ehControle && !isAcaoPreAprovacaoCadastro) {
      return model.getModel('pontoDeControle.descricao').value;
    }
    if (ehPerdaOperacional && !isAcaoPreAprovacaoCadastro) {
      return model.getModel('perdaOperacional.nome').value;
    }
    if (ehPesquisaClima && !isAcaoPreAprovacaoCadastro) {
      return model.getModel('pesquisaClima.nome').value;
    }
    if (ehOcorrencia && !isAcaoPreAprovacaoCadastro) {
      return (
        model.getModel('ocorrencia.titulo').value ||
        model.getModel('nomeItem').value
      );
    }
    if (
      itemId &&
      !isAcaoPreAprovacaoCadastro &&
      !ehAuditoria &&
      !ehControlSelfAssessment &&
      !ehControle &&
      !ehPerdaOperacional &&
      !ehPesquisaClima &&
      !ehOcorrencia &&
      model.getModel('item').value
    ) {
      return (
        <DropDownItem
          item={model.getModel('item').value}
          noPadding
          link={false}
        />
      );
    }
    return null;
  }

  renderInfoBasicaEdicaoResumo({
    model,
    intl,
    resources,
    ehControlSelfAssessment,
    ehAuditoria,
    ehControle,
    ehPerdaOperacional,
    ehPesquisaClima,
    ehOcorrencia,
    isAcaoPreAprovacaoCadastro,
    itemId,
    mostrarTipoOrigem,
    tipoOrigemDescricao,
    mostrarFarolAcao,
    farolAcaoResumo,
  }) {
    const itemConteudo = this.renderItemPrincipalConteudo({
      model,
      ehControlSelfAssessment,
      ehAuditoria,
      ehControle,
      ehPerdaOperacional,
      ehPesquisaClima,
      ehOcorrencia,
      isAcaoPreAprovacaoCadastro,
      itemId,
    });

    const mostrarItemOrigem =
      model.getModel('itemAcaoOrigem')?.value &&
      !isAcaoPreAprovacaoCadastro &&
      !ehAuditoria &&
      !ehControlSelfAssessment &&
      !ehControle &&
      !ehPerdaOperacional &&
      !ehPesquisaClima &&
      !ehOcorrencia;

    const mostrarAcaoOrigem =
      model.getModel('acaoOrigem')?.value && !isAcaoPreAprovacaoCadastro;

    const mostrarLinha1Item = itemConteudo != null;
    const mostrarLinha1Farol = mostrarFarolAcao && farolAcaoResumo;
    const mostrarLinha1 =
      mostrarLinha1Item || mostrarTipoOrigem || mostrarLinha1Farol;

    if (!mostrarLinha1 && !mostrarItemOrigem && !mostrarAcaoOrigem) {
      return null;
    }

    const labelItem = capitalizeFirstLetter(intl.formatMessage({ id: 'item' }));
    const labelFarol = capitalizeFirstLetter(resources.farol);

    return (
      <>
        {mostrarLinha1 && (
          <div className={classes.infoBasicaEdicaoLinha1}>
            {mostrarLinha1Item && (
              <div className={classes.infoBasicaEdicaoItem}>
                <b>{labelItem}&nbsp;</b>
                <span className={classes.infoBasicaEdicaoItemValor}>
                  {itemConteudo}
                </span>
              </div>
            )}
            {(mostrarTipoOrigem || mostrarLinha1Farol) && (
              <div className={classes.infoBasicaEdicaoMeta}>
                {mostrarTipoOrigem &&
                  this.renderTipoOrigemBadge(tipoOrigemDescricao)}
                {mostrarLinha1Farol &&
                  this.renderCampoSomenteLeitura(
                    labelFarol,
                    <SvgIcon
                      icon={farolAcaoResumo.icone}
                      size={farolAcaoResumo.tamanho || 12}
                      color={farolAcaoResumo.cor}
                      colorHover={farolAcaoResumo.cor}
                      title={farolAcaoResumo.descricao}
                    />
                  )}
              </div>
            )}
          </div>
        )}
        {mostrarItemOrigem && (
          <Row className="mb-3">
            <Col md={12}>
              {this.renderCampoSomenteLeitura(
                capitalizeFirstLetter(intl.formatMessage({ id: 'itemOrigem' })),
                <ItemLink
                  className="link-primary"
                  isConsultaExterna={
                    this.props.disabled || this.props.disabledEdit
                  }
                  model={model.getModel('itemAcaoOrigem')}
                />
              )}
            </Col>
          </Row>
        )}
        {mostrarAcaoOrigem && (
          <Row className="mb-3">
            <Col md={12}>
              {this.renderCampoSomenteLeitura(
                capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'label.acaoOrigem' },
                    { acao: resources.acao }
                  )
                ),
                <ItemLink
                  className="link-primary"
                  isConsultaExterna={
                    this.props.disabled || this.props.disabledEdit
                  }
                  afterSave={this.afterSave}
                  tipo={901}
                  model={model.getModel('acaoOrigem')}
                />
              )}
            </Col>
          </Row>
        )}
      </>
    );
  }
  render() {
    let {
      model,
      resources,
      intl,
      moduloAtual,
      parameters,
      paramsFiltro,
      modules,
    } = this.props;
    let acaoId = model.getModel('id').value;
    const somenteLeitura =
      this.props.disabled === true || this.props.disabledEdit === true;

    const isNew = acaoId == 0;
    const isAcaoPreAprovacaoCadastro =
      model &&
      model.getModel('aprovarCadastro') &&
      model.getModel('aprovarCadastro').value &&
      (isNew ||
        (model.getModel('status') &&
          (model.getModel('status').value.id == STATUS_ACAO.PENDENTE_CADASTRO ||
            model.getModel('status').value.id == STATUS_ACAO.REPROVADA)));

    const isAcaoAprovacaoReprovada =
      model &&
      model.getModel('aprovarCadastro') &&
      model.getModel('aprovarCadastro').value &&
      model.getModel('status') &&
      model.getModel('status').value.id == STATUS_ACAO.REPROVADA;

    const idsStatus = isAcaoAprovacaoReprovada ? [8, 9] : [1, 2, 3, 4, 5, 6, 7];

    let { editarAcaoOrigem, editarEsforco, permissoesAcaoValor } = this.state;

    // habilitar edição de campos se não tiver filho
    let listIdFilhos = model.getModel('filhos');
    let temFilhos =
      listIdFilhos.value === null ||
      (listIdFilhos.value && listIdFilhos.value.length === 0)
        ? false
        : true;

    let {
      editarDemaisCampos,
      editarDataPrevista,
      editarDataRealizadaPercentualObservacao,
    } = model.value;
    if (somenteLeitura) {
      editarDemaisCampos = false;
      editarDataPrevista = false;
      editarDataRealizadaPercentualObservacao = false;
      editarAcaoOrigem = false;
      editarEsforco = false;
    }
    let ehAcaoVinculada =
      model &&
      model.getModel('ehAcaoVinculada') &&
      model.getModel('ehAcaoVinculada').value;
    let allowEdit =
      model &&
      model.getModel('permissions') &&
      model.getModel('permissions').value &&
      model.getModel('permissions').value.allowEdit;
    let registroPreenchido = false;
    let configuracoes = this.state.configuracoes;
    let bloquearCodigoAutomatico =
      configuracoes.model &&
      configuracoes.model.permitirAlterarCodigoAutomatico == false &&
      configuracoes.model.utilizarCodigoAutomatico == true
        ? true
        : false;

    const ehAuditoria =
      model.getModel('auditoriaRisco').value != null ? true : false;
    const ehPerdaOperacional = model.getModel('perdaOperacional').value != null;
    const ehPesquisaClima =
      model.getModel('pesquisaClima').value != null ||
      Number(parameters?.tipoOrigemId) === TIPO_ORIGEM.PESQUISA_CLIMA;
    const ehOcorrencia =
      model.getModel('ocorrencia').value != null ||
      Number(parameters?.tipoOrigemId) === TIPO_ORIGEM.OCORRENCIA;
    const ehTesteControle = model.getModel('testeControle').value != null;
    const ehControlSelfAssessment =
      model.getModel('controlSelfAssessment').value != null ? true : false;
    const ehControle =
      model.getModel('pontoDeControle').value != null ? true : false;

    let tipoOrigemModel = null;

    if (
      !ehAuditoria &&
      !ehControlSelfAssessment &&
      !ehControle &&
      !ehPerdaOperacional &&
      !ehPesquisaClima &&
      !ehOcorrencia &&
      !ehTesteControle
    )
      tipoOrigemModel = model.getModel('item').value;

    let tipoOrigem;
    //Ação criada via teste de controle que envia pontoControleId e testeControleId
    if (ehControle && ehTesteControle) {
      tipoOrigem = 'testeControle';
    } else {
      tipoOrigem = model.getModel('auditoriaRiscoChecklistPergunta').value
        ? 'auditoriaChecklist'
        : ehAuditoria
        ? 'auditoria'
        : ehControlSelfAssessment
        ? 'controlSelfAssessment'
        : ehControle
        ? 'pontoDeControle'
        : ehPerdaOperacional
        ? 'perdaOperacional'
        : ehPesquisaClima
        ? 'pesquisaClima'
        : ehOcorrencia
        ? 'ocorrencia'
        : ehTesteControle
        ? 'testeControle'
        : tipoOrigemModel &&
          tipoOrigemModel.tipo &&
          tipoOrigemModel.tipo.resources;
    }

    if (model.getModel('tipoAcao').value == 0) {
      if (this.props.parameters && this.props.parameters.relatorioId) {
        model.getModel('tipoAcao').requestChange(2);
      } else {
        model.getModel('tipoAcao').requestChange(1);
      }
    }

    if (allowEdit == null) {
      allowEdit = true;
    }
    if (somenteLeitura) allowEdit = false;

    if (
      (model.getModel('descricao') && model.getModel('descricao').value) ||
      (model.getModel('responsavel') && model.getModel('responsavel').value)
    ) {
      registroPreenchido = true;
    }

    let itemId =
      this.props.parameters && this.props.parameters.itemId
        ? this.props.parameters.itemId
        : model.getModel('item').value && model.getModel('item').value.id;
    let centroCustoId =
      this.props.parameters && this.props.parameters.centroCustoId
        ? this.props.parameters.centroCustoId
        : model.getModel('centroCusto').value &&
          model.getModel('centroCusto').value.id;
    let pacoteId =
      this.props.parameters && this.props.parameters.pacoteId
        ? this.props.parameters.pacoteId
        : model.getModel('pacote').value && model.getModel('pacote').value.id;

    if (!itemId) {
      itemId =
        window.location && qs.parse(window.location.search).itemId
          ? qs.parse(window.location.search).itemId
          : null;
    }

    if (paramsFiltro) {
      if (paramsFiltro.item && model.getModel('item').value == null)
        model.getModel('item').requestChange(paramsFiltro.item);

      if (
        paramsFiltro.centroCusto &&
        model.getModel('centroCusto').value == null
      )
        model.getModel('centroCusto').requestChange(paramsFiltro.centroCusto);

      if (paramsFiltro.pacote && model.getModel('pacote').value == null)
        model.getModel('pacote').requestChange(paramsFiltro.pacote);
    }

    let responsavelOpcional =
      configuracoes && configuracoes.model
        ? configuracoes.model.responsavelOpcional
        : false;

    this.fillPontosProblematicos();

    const hasAction = acaoId > 0;
    const exibirLookups = parameters?.exibirLookups ?? true;
    const exibirCampoCodigoImportacao =
      parameters?.exibirCampoCodigoImportacao ?? false;
    const hasEPModule = modules.find(
      (m) => m.id === MODULOS.ESCRITORIO_PROJETOS && m.ativo
    );
    const hasBELT = modules.find(
      (m) => m.id === MODULOS.GESTAO_RISCO && m.ativo
    );

    const canEditResponsavel =
      !somenteLeitura && model.getModel('habilitarResponsavel').value;

    const disabledDataRealizada =
      model &&
      model.getModel('tipoCalculoFarolAcao') &&
      model.getModel('tipoCalculoFarolAcao').value &&
      model.getModel('tipoCalculoFarolAcao').value.id == 2 &&
      model.getModel('status') &&
      model.getModel('status').value &&
      model.getModel('status').value.id != STATUS_ACAO.EM_PLANEJAMENTO &&
      model.getModel('status').value.id != STATUS_ACAO.NAO_INICIADA;

    const itemIdModel =
      this.props.model.getModel('item').value &&
      this.props.model.getModel('item').value.id;

    const pacoteIdModel =
      this.props.model.getModel('pacote').value &&
      this.props.model.getModel('pacote').value.id;

    const centroCustoIdModel =
      this.props.model.getModel('centroCusto').value &&
      this.props.model.getModel('centroCusto').value.id;

    const habilitarRegistroSuperior =
      !!(itemId || centroCustoId || pacoteId) && !isAcaoPreAprovacaoCadastro;

    const mostrarStatus =
      !isAcaoPreAprovacaoCadastro || isAcaoAprovacaoReprovada;
    const mostrarTipoAcao = !!configuracoes?.model?.tipoAcao;
    const mostrarTipoOrigem = !!configuracoes?.model?.tipoOrigem;
    const mostrarPercentualPrevisto =
      !!configuracoes?.model?.utilizarPercentualPrevisto &&
      !isAcaoPreAprovacaoCadastro;

    const utilizarPlanoContas =
      configuracoes.model && configuracoes.model.utilizarPlanoContas;

    const podeEditarCusteioInvestimento =
      !model.getModel('item') ||
      !model.getModel('item').value ||
      (model.getModel('item') &&
        model.getModel('item').value &&
        (model.getModel('item').value.tipo.id != 4 ||
          (model.getModel('item').value.tipo.id == 4 && !utilizarPlanoContas)));

    //* Desenvolvido para licitação, será comentado para, caso necessário, ser usado novamente
    // const utilizarDetalhamentoFinanceiro =
    //   configuracoes.model &&
    //   configuracoes.model.utilizarDetalhamentoFinanceiro &&
    //   model.getModel('item') &&
    //   model.getModel('item').value &&
    //   model.getModel('item').value.tipo.id == 4;

    const resumoDescricao = model.getModel('descricao')?.value || '-';
    const resumoStatus = model.getModel('status')?.value?.descricao || '-';
    const farolAcaoResumo = model.getModel('farolAcao')?.value;
    const tipoOrigemDescricao =
      tipoOrigem == null && (pacoteId || centroCustoId)
        ? capitalizeFirstLetter(resources.orcamento)
        : tipoOrigem === 'reuniao'
        ? intl.formatMessage({ id: 'reuniao' })
        : tipoOrigem === 'auditoria'
        ? capitalizeFirstLetter(resources.auditoria)
        : tipoOrigem === 'perdaOperacional'
        ? capitalizeFirstLetter(resources.perdaoperacional)
        : tipoOrigem === 'pesquisaClima'
        ? capitalizeFirstLetter(resources.pesquisa)
        : tipoOrigem === 'auditoriaChecklist'
        ? this.props.intl.formatMessage(
            { id: 'titulo.auditoriaChecklist' },
            { auditoria: resources.auditoria }
          )
        : tipoOrigem === 'controlSelfAssessment'
        ? intl.formatMessage({ id: 'labelControlSelfAssessment' })
        : tipoOrigem === 'pontoDeControle'
        ? capitalizeFirstLetter(resources.pontodecontrole)
        : tipoOrigem === 'testeControle'
        ? capitalizeFirstLetter(
            intl.formatMessage(
              { id: 'labelTesteControle' },
              { testeControle: resources.testeControle }
            )
          )
        : tipoOrigem
        ? capitalizeFirstLetter(resources[tipoOrigem])
        : '-';
    const grauRiscoDescricao =
      model.getModel('grauRisco').value?.descricao ||
      model.getModel('grauRisco.descricao').value ||
      '-';
    const grauRiscoCor =
      model.getModel('grauRisco').value?.cor ||
      model.getModel('grauRisco.cor').value ||
      '#71717A';
    const mostrarMatrizRisco =
      hasBELT &&
      configuracoes?.model?.vincularAcaoNaMatriz &&
      model.getModel('descricaoMatrizRisco').value;

    const mostrarGrauRisco =
      hasBELT &&
      configuracoes?.model?.exibirGrauDescricaoAcaoVinculadaRisco &&
      tipoOrigem === 'risco';

    const mostrarFarolAcao = !!model.getModel('farolAcao').value;
    const resumoItem = ehOcorrencia
      ? model.getModel('ocorrencia.titulo').value ||
        model.getModel('nomeItem').value ||
        '-'
      : model.getModel('item')?.value?.nome ||
        model.getModel('centroCusto')?.value?.descricao ||
        model.getModel('pesquisaClima')?.value?.nome ||
        '-';
    const resumoInicioPrevisto = model.getModel('dataInicioPrevista')?.value
      ? formatarData(
          this.props.user.idioma,
          model.getModel('dataInicioPrevista').value
        )
      : '-';
    const resumoTerminoPrevisto = model.getModel('dataTerminoPrevista')?.value
      ? formatarData(
          this.props.user.idioma,
          model.getModel('dataTerminoPrevista').value
        )
      : '-';

    const secaoInfoBasica = (
      <>
        {hasAction &&
          this.renderInfoBasicaEdicaoResumo({
            model,
            intl,
            resources,
            ehControlSelfAssessment,
            ehAuditoria,
            ehControle,
            ehPerdaOperacional,
            ehPesquisaClima,
            ehOcorrencia,
            isAcaoPreAprovacaoCadastro,
            itemId,
            mostrarTipoOrigem,
            tipoOrigemDescricao,
            mostrarFarolAcao,
            farolAcaoResumo,
          })}
        <Row className="acao-step2">
          <Col md={12}>
            <Input
              rows={3}
              type="textarea"
              required={isNew}
              disabled={!editarDemaisCampos}
              placeholder={
                isNew
                  ? intl.formatMessage(
                      { id: 'labelDescricaoDaAcao' },
                      { acao: resources.acao }
                    )
                  : undefined
              }
              model={model.getModel('descricao')}
            />
          </Col>
        </Row>
        {/* Item + Código Importação */}
        {!hasAction && ehOcorrencia && (
          <div className="tw:mb-4">
            {this.renderCampoSomenteLeitura(
              capitalizeFirstLetter(intl.formatMessage({ id: 'item' })),
              resumoItem
            )}
          </div>
        )}
        {(exibirLookups === true || model.getModel('item').value) &&
          moduloAtual &&
          moduloAtual.id !== MODULOS.MATRIZ_ORCAMENTARIA && (
            <>
              {!hasAction && !ehOcorrencia && (
                <Row className="acao-step3">
                  <Col md={12}>
                    <ItemLookup
                      required
                      clearable={true}
                      disabled={!editarDemaisCampos}
                      model={{
                        label: capitalizeFirstLetter(
                          intl.formatMessage({ id: 'item' })
                        ),
                        value: model.getModel('item').value,
                        requestChange: model.getModel('item').requestChange,
                        errors: model.getModel('item').errors,
                      }}
                      data={{
                        tiposIdsIgnorar: [
                          TIPO_ITENS.PARAMETRO,
                          TIPO_ITENS.INDICADOR_RISCO,
                          TIPO_ITENS.CALIBRACAO,
                        ],
                        tiposStatusIgnorar: [
                          STATUS_ITEM.CONCLUIDO,
                          STATUS_ITEM.CANCELADO,
                        ],
                        ehTelaAcao: true,
                      }}
                    />
                  </Col>
                </Row>
              )}
              {this.renderCampoCodigoImportacao({
                model,
                bloquearCodigoAutomatico,
                editarDemaisCampos,
                paiAlterado: this.state.paiAlterado,
              })}
            </>
          )}

        {exibirCampoCodigoImportacao &&
          exibirLookups === false &&
          !model.getModel('item').value &&
          this.renderCampoCodigoImportacao({
            model,
            bloquearCodigoAutomatico,
            editarDemaisCampos,
            paiAlterado: this.state.paiAlterado,
          })}

        {/* Pacote/Conta + Centro de Custo (MO) */}
        {exibirLookups &&
          moduloAtual &&
          moduloAtual.id === MODULOS.MATRIZ_ORCAMENTARIA && (
            <>
              <Row>
                <Col md={12}>
                  <PacoteLookup
                    required={model.getModel('centroCusto').value == null}
                    clearable={true}
                    disabled={!editarDemaisCampos}
                    model={{
                      label: intl.formatMessage({ id: 'pacote' }),
                      value: model.getModel('pacote').value,
                      requestChange: model.getModel('pacote').requestChange,
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <CentroCustoLookup
                    required={model.getModel('pacote').value == null}
                    clearable={true}
                    disabled={!editarDemaisCampos}
                    model={{
                      label: capitalizeFirstLetter(
                        intl.formatMessage(
                          { id: 'centroCusto' },
                          { centrocusto: resources.centrocusto }
                        )
                      ),
                      value: model.getModel('centroCusto').value,
                      requestChange:
                        model.getModel('centroCusto').requestChange,
                    }}
                  />
                </Col>
              </Row>
            </>
          )}

        {/* Registro superior + Status + Tipo ação + Tipo origem */}
        <Row>
          <Col md={12}>
            <AcaoLookup
              model={{
                label: model.getModel('pai').label,
                value: model.getModel('pai').value,
                requestChange: this.handleChangeAcaoSuperior,
              }}
              disabled={
                !habilitarRegistroSuperior ||
                !editarDemaisCampos ||
                this.props.preventParentChange
              }
              data={{
                itemId: itemIdModel ?? itemId,
                centroCustoId: centroCustoIdModel ?? centroCustoId,
                pacoteId: pacoteIdModel ?? pacoteId,
                acaoId,
                relatorioId:
                  this.props.parameters && this.props.parameters.relatorioId,
                filtrarAcoesVinculadas: true,
                ignorarAcaoId: true,
                isGanttSearch: this.props.isGanttSearch,
              }}
            />
          </Col>
        </Row>
        {mostrarStatus && (
          <Row>
            <Col md={12}>
              <StatusAcaoLookup
                model={{
                  label: model.getModel('status').label,
                  value: model.getModel('status').value,
                  requestChange: model.getModel('status').requestChange,
                }}
                disabled={
                  somenteLeitura ||
                  (isAcaoPreAprovacaoCadastro
                    ? false
                    : !editarDemaisCampos || temFilhos)
                }
                data={{ exibirApenas: idsStatus }}
                required
              />
            </Col>
          </Row>
        )}
        {mostrarTipoAcao && (
          <Row>
            <Col md={12}>
              <TipoAcaoLookup
                disabled={!editarDemaisCampos}
                clearable={false}
                required
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'tipoAcao' },
                      { acao: resources.acao }
                    )
                  ),
                  value:
                    model.getModel('tipoAcao').value == null
                      ? null
                      : { id: model.getModel('tipoAcao').value },
                  requestChange: (value) =>
                    model
                      .getModel('tipoAcao')
                      .requestChange(value && value.id ? value.id : value),
                }}
              />
            </Col>
          </Row>
        )}
        {/* Farol */}
        {!hasAction && mostrarFarolAcao && (
          <Row>
            <Col md={12}>
              <InputGroup
                disabled
                model={{
                  label: capitalizeFirstLetter(resources.farol),
                  value: model.getModel('farolAcao').value.descricao || '',
                  requestChange: () => {},
                }}
                addon={
                  <SvgIcon
                    icon={model.getModel('farolAcao').value.icone}
                    size={model.getModel('farolAcao').value.tamanho}
                    color={model.getModel('farolAcao').value.cor}
                  />
                }
              />
            </Col>
          </Row>
        )}

        {/* Responsável + Equipe */}
        <Row className="acao-step4">
          <Col md={12}>
            <ResponsavelButtonLookup
              formGroupStyle={{ marginBottom: 16 }}
              showLabel
              exibirInputDireto
              disabled={canEditResponsavel ? false : !editarDemaisCampos}
              required={!responsavelOpcional}
              tipoLookup="acao"
              acaoId={acaoId}
              fromAcao
              multi={false}
              model={{
                label: capitalizeFirstLetter(resources.responsavel),
                value: model.getModel('responsavel').value,
                requestChange: model.getModel('responsavel').requestChange,
                errors: model.getModel('responsavel').errors,
              }}
            />
          </Col>
        </Row>
        {configuracoes?.model?.habilitarEquipe && (
          <Row>
            <Col md={12}>
              <ColaboradorLookup
                multi
                disabled={!editarDemaisCampos}
                model={model.getModel('equipe')}
              />
            </Col>
          </Row>
        )}

        {/* Aprovar cadastro */}
        {isNew &&
          !parameters.isTemplateProjeto &&
          configuracoes?.model?.utilizarAprovacaoAcoes && (
            <Row>
              <Col md={12}>
                <div className={classes.aprovarCadastroField}>
                  <Checkbox
                    style={{ marginBottom: 0 }}
                    model={{
                      label: intl.formatMessage(
                        { id: 'aprovarCadastroAcoes' },
                        { acao: resources.acao, acoes: resources.acoes }
                      ),
                      value: model.getModel('aprovarCadastro').value,
                      requestChange:
                        model.getModel('aprovarCadastro').requestChange,
                    }}
                  />
                </div>
              </Col>
            </Row>
          )}

        {configuracoes?.model?.podeVisualizarTag && (
          <TagLookup
            multi
            model={{
              label: capitalizeFirstLetter(
                intl.formatMessage({ id: 'tags' }, { tags: resources.tags })
              ),
              value: model.getModel('tags').value,
              requestChange: model.getModel('tags').requestChange,
            }}
            disabled={!editarDemaisCampos}
            data={{ funcionalidadesIdSelecionaveis: [6] }}
            podeEditar={model.getModel('podeCadastrarTag').value}
          />
        )}
        {configuracoes?.model?.utilizarObservacao && (
          <Input
            rows={3}
            type="textarea"
            disabled={!editarDataRealizadaPercentualObservacao}
            model={{
              label: capitalizeFirstLetter(resources.observacaoacao),
              value: model.getModel('observacao').value,
              requestChange: model.getModel('observacao').requestChange,
            }}
          />
        )}
        {configuracoes?.model?.utilizarCausasImpactadas &&
          !isAcaoPreAprovacaoCadastro && (
            <ResponsiveList
              disabled={!editarDemaisCampos}
              acaoId={acaoId}
              tarefas={model.getModel('pontosProblematicos')}
              titulo={resources.pontosproblematicos}
              hideAddButton={this.validaSeNaoPodeAdicionarCausa(
                model.getModel('pontosProblematicos').value
              )}
            />
          )}

        <div className={classes.anexosComentariosRow}>
          <span className={classes.anexosInline}>
            <span className={classes.anexosInlineLabel}>
              <FormattedMessage id="label.anexos" />
            </span>
            <ArquivoUploadAnexos
              disabled={!editarDemaisCampos}
              disabledClick={!editarDemaisCampos && !somenteLeitura}
              onlyRead={somenteLeitura}
              iconSize={16}
              tipoAnexo={this.props.tiposAnexos.acao}
              classNameFormGroup="d-inline-flex align-items-center mb-0"
              formGroupStyle={{ marginBottom: 0 }}
              maxWidth="none"
              model={{
                value: model.getModel('arquivos').value,
                requestChange: model.getModel('arquivos').requestChange,
              }}
            />
          </span>
        </div>

        {acaoId > 0 && (
          <div className={classes.anexosComentariosRow}>
            <ComentarioButton
              disabled={somenteLeitura}
              item={model.value}
              tipoEntidade={7}
              dialogTitle={buildComentarioDialogTitle(
                intl,
                model.getModel('descricao')?.value,
                extractPeriodoDescricao(model.value)
              )}
              onCountChange={() => this.setState({})}
            />
          </div>
        )}

        {model.getModel('camposCustomizados').value &&
          model.getModel('camposCustomizados').value.length > 0 && (
            <DesenharCampoCustomizado
              colValue={12}
              model={model.getModel('camposCustomizados')}
              disabled={!editarDemaisCampos}
            />
          )}
      </>
    );

    const secaoCronograma = (
      <>
        <Row>
          <Col md={3}>
            <DatePicker
              timeFormat={false}
              autoFormatDate={true}
              inputTextAlign="left"
              model={{
                value: model.getModel('dataInicioPrevista').value,
                label: intl.formatMessage({ id: 'label.inicioPrevisto' }),
                requestChange: this.handleChangeDataInicioPrevista,
                errors: model.getModel('dataInicioPrevista').errors,
              }}
              onFocus={() => this.handleSelectDate('dataInicioPrevista')}
              disabled={
                !editarDataPrevista ||
                temFilhos ||
                model.getModel('predecessoras').value
              }
              required={model.getModel('datasPrevistasObrigatorias').value}
            />
          </Col>
          <Col md={3}>
            <DatePicker
              timeFormat={false}
              autoFormatDate={true}
              inputTextAlign="left"
              model={{
                value: model.getModel('dataTerminoPrevista').value,
                label: intl.formatMessage({ id: 'label.terminoPrevisto' }),
                errors: model.getModel('dataTerminoPrevista').errors,
                requestChange: this.handleChangeDataTerminoPrevisto,
              }}
              onFocus={() => this.handleSelectDate('dataTerminoPrevista')}
              disabled={!editarDataPrevista || temFilhos}
              required={model.getModel('datasPrevistasObrigatorias').value}
            />
          </Col>
          {mostrarPercentualPrevisto && (
            <Col md={3}>
              <InputNumber
                precision={2}
                disabled={true}
                model={{
                  label: `% ${capitalizeFirstLetter(
                    intl.formatMessage({ id: 'label.previsto' })
                  )}`,
                  value: model.getModel('percentualPrevisto').value,
                  requestChange:
                    model.getModel('percentualPrevisto').requestChange,
                }}
              />
            </Col>
          )}
          <Col md={3}>
            <InputNumber
              min={0}
              model={{
                value: model.getModel('duracao').value,
                label: (
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    {model.getModel('duracao').label}
                    <Info
                      id="duracao-hint"
                      placement="right"
                      className="pl-1"
                      tooltipMaxWidth={250}
                      renderContent={() => (
                        <div>
                          <div>
                            {intl.formatMessage({
                              id: 'label.duracaoEmDiasUteis',
                            })}
                          </div>
                          <div>
                            {intl.formatMessage({ id: 'label.diasDecorridos' })}{' '}
                            {this.state.diasDecorridos}
                          </div>
                        </div>
                      )}
                    />
                  </span>
                ),
                requestChange: this.handleChangeDuracao,
              }}
              disabled={!editarDataPrevista || temFilhos}
            />
          </Col>
        </Row>

        {configuracoes?.model?.habilitarBaseline &&
          !isAcaoPreAprovacaoCadastro && (
            <Row>
              <Col md={3}>
                <Input
                  disabled
                  model={{
                    label: intl.formatMessage({ id: 'baselineInicial' }),
                    value: model.getModel('baselineInicial').value
                      ? formatarData(
                          this.props.user.idioma,
                          model.getModel('baselineInicial').value,
                          true
                        )
                      : '-',
                    requestChange: () => {},
                  }}
                />
              </Col>
              <Col md={3}>
                <Input
                  disabled
                  model={{
                    label: intl.formatMessage({ id: 'baselineTermino' }),
                    value: model.getModel('baselineTermino').value
                      ? formatarData(
                          this.props.user.idioma,
                          model.getModel('baselineTermino').value,
                          true
                        )
                      : '-',
                    requestChange: () => {},
                  }}
                />
              </Col>
            </Row>
          )}

        {!isAcaoPreAprovacaoCadastro && (
          <Row>
            <Col md={3}>
              <DatePicker
                timeFormat={false}
                autoFormatDate={true}
                inputTextAlign="left"
                disabledDate={disabledDate}
                model={{
                  label: intl.formatMessage({ id: 'label.inicioRealizado' }),
                  value: model.getModel('dataInicioRealizada').value,
                  requestChange: this.handleChangedataInicioRealizada,
                }}
                onFocus={() => this.handleSelectDate('dataInicioRealizada')}
                disabled={
                  disabledDataRealizada ||
                  !editarDataRealizadaPercentualObservacao ||
                  temFilhos
                }
              />
            </Col>
            <Col md={3}>
              <DatePicker
                timeFormat={false}
                autoFormatDate={true}
                inputTextAlign="left"
                model={{
                  label: intl.formatMessage({ id: 'label.terminoRealizado' }),
                  value: model.getModel('dataTerminoRealizada').value,
                  requestChange: model.getModel('dataTerminoRealizada')
                    .requestChange,
                }}
                onFocus={() => this.handleSelectDate('dataTerminoRealizada')}
                disabled={
                  disabledDataRealizada ||
                  !editarDataRealizadaPercentualObservacao ||
                  temFilhos
                }
              />
            </Col>
            {configuracoes?.model?.utilizarPercentualRealizado && (
              <Col md={3}>
                <InputNumber
                  precision={2}
                  disabled={
                    !editarDataRealizadaPercentualObservacao || temFilhos
                  }
                  model={{
                    label: `% ${capitalizeFirstLetter(
                      intl.formatMessage({ id: 'realizado' })
                    )}`,
                    value: model.getModel('percentualRealizado').value,
                    requestChange: this.handleChangePercentualRealizado,
                  }}
                />
              </Col>
            )}
            {configuracoes?.model?.utilizarEsforco && (
              <Col md={3}>
                <InputNumber
                  precision={2}
                  model={model.getModel('esforco')}
                  disabled={!editarDemaisCampos || !editarEsforco || temFilhos}
                />
              </Col>
            )}
          </Row>
        )}
      </>
    );

    const custoInvestimentoDisabled =
      !editarDemaisCampos || !podeEditarCusteioInvestimento;
    const labelCustoPrevisto = capitalizeFirstLetter(
      intl.formatMessage({ id: 'label.previsto' })
    );
    const labelCustoRealizado = capitalizeFirstLetter(
      intl.formatMessage({ id: 'realizado' })
    );

    const renderCustoRow = (fields) => {
      const visibleFields = fields.filter((field) => field.show);
      if (!visibleFields.length) {
        return null;
      }

      return (
        <Row>
          {visibleFields.map((field) => (
            <Col md={6} key={field.modelKey}>
              <InputNumber
                precision={2}
                model={{
                  label: field.label,
                  value: model.getModel(field.modelKey).value,
                  requestChange: model.getModel(field.modelKey).requestChange,
                }}
                disabled={custoInvestimentoDisabled}
              />
            </Col>
          ))}
        </Row>
      );
    };

    const camposInvestimento = [
      {
        show: configuracoes?.model?.utilizarInvestimentoPrevisto,
        modelKey: 'investimentoPrevisto',
        label: `${capitalizeFirstLetter(
          resources.investimento
        )} ${labelCustoPrevisto}`,
      },
      {
        show: configuracoes?.model?.utilizarInvestimentoRealizado,
        modelKey: 'investimentoRealizado',
        label: `${capitalizeFirstLetter(
          resources.investimento
        )} ${labelCustoRealizado}`,
      },
    ];

    const camposCusteio = [
      {
        show: configuracoes?.model?.utilizarCusteioPrevisto,
        modelKey: 'custeioPrevisto',
        label: `${capitalizeFirstLetter(
          resources.custeio
        )} ${labelCustoPrevisto}`,
      },
      {
        show: configuracoes?.model?.utilizarCusteioRealizado,
        modelKey: 'custeioRealizado',
        label: `${capitalizeFirstLetter(
          resources.custeio
        )} ${labelCustoRealizado}`,
      },
    ];

    const secaoCustos = (
      <>
        {hasEPModule && (
          <Row>
            <Col md={12}>
              <InputNumber
                precision={2}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'custoAcao' },
                      { acao: resources.acao }
                    )
                  ),
                  value: model.getModel('custo').value,
                  requestChange: model.getModel('custo').requestChange,
                }}
                disabled={!editarDemaisCampos}
              />
            </Col>
          </Row>
        )}
        {renderCustoRow(camposInvestimento)}
        {renderCustoRow(camposCusteio)}
        {/* Detalhamento de custo */}
        {(!podeEditarCusteioInvestimento ||
          model.getModel('podeEditarInvestimentoPrevisto')?.value === false ||
          model.getModel('podeEditarCusteioPrevisto')?.value === false) &&
          ((model.getModel('investimentoPrevisto').value != null &&
            model.getModel('investimentoPrevisto').value !== 0) ||
            (model.getModel('investimentoRealizado').value != null &&
              model.getModel('investimentoRealizado').value !== 0) ||
            (model.getModel('custeioPrevisto').value != null &&
              model.getModel('custeioPrevisto').value !== 0) ||
            (model.getModel('custeioRealizado').value != null &&
              model.getModel('custeioRealizado').value !== 0)) && (
            <Row>
              <Col md={4}>
                <div
                  onClick={() =>
                    ContentManager.addContent(
                      <DetalhamentoInvestimentoCusteioModal
                        acaoId={acaoId}
                        resources={resources}
                      />
                    )
                  }
                  className="d-flex align-items-center text-primary cursor-pointer font-weight-bolder"
                >
                  <FormattedMessage id="label.detalhamento" />
                </div>
              </Col>
            </Row>
          )}
      </>
    );

    const secaoChecklist =
      configuracoes?.model?.habilitarChecklistTarefas &&
      !isAcaoPreAprovacaoCadastro ? (
        <InlineChecklist
          disabled={!editarDemaisCampos}
          acaoId={acaoId}
          itens={model.getModel('tarefas').value || []}
          setItens={(items) => {
            if (!somenteLeitura) model.getModel('tarefas').requestChange(items);
          }}
          labelKey="checklistTarefas"
          addButtonLabelKey="tarefa"
          itemColumnLabelKey="tarefa"
          showTags={false}
          showTransformarProjeto={false}
          showSummaryHeader={false}
          showTarefasColumn={false}
          habilitarOrdenacao={!somenteLeitura}
          permissions={
            somenteLeitura
              ? {
                  ...model.getModel('permissions')?.value,
                  allowEdit: false,
                  allowDelete: false,
                }
              : model.getModel('permissions')?.value != null
              ? model.getModel('permissions').value
              : null
          }
        />
      ) : null;

    const secao5W2H = (
      <>
        {configuracoes?.model?.utilizarComo && !isAcaoPreAprovacaoCadastro && (
          <Row>
            <Col md={12}>
              <Input
                rows={1}
                type="textarea"
                disabled={!editarDemaisCampos}
                placeholder={intl.formatMessage({ id: 'placeholderComo' })}
                model={{
                  label: capitalizeFirstLetter(resources.como),
                  value: model.getModel('como').value,
                  requestChange: model.getModel('como').requestChange,
                }}
              />
            </Col>
          </Row>
        )}
        {configuracoes?.model?.utilizarOnde && !isAcaoPreAprovacaoCadastro && (
          <Row>
            <Col md={12}>
              <Input
                rows={1}
                type="textarea"
                disabled={!editarDemaisCampos}
                placeholder={intl.formatMessage({ id: 'placeholderOnde' })}
                model={{
                  label: capitalizeFirstLetter(resources.onde),
                  value: model.getModel('onde').value,
                  requestChange: model.getModel('onde').requestChange,
                }}
              />
            </Col>
          </Row>
        )}
        {configuracoes?.model?.utilizarPorque &&
          !isAcaoPreAprovacaoCadastro && (
            <Row>
              <Col md={12}>
                <Input
                  rows={1}
                  type="textarea"
                  disabled={!editarDemaisCampos}
                  placeholder={intl.formatMessage({ id: 'placeholderPorQue' })}
                  model={{
                    label: capitalizeFirstLetter(resources.porque),
                    value: model.getModel('porque').value,
                    requestChange: model.getModel('porque').requestChange,
                  }}
                />
              </Col>
            </Row>
          )}
      </>
    );

    const secaoRisco =
      mostrarMatrizRisco || mostrarGrauRisco ? (
        <>
          <Row>
            {mostrarMatrizRisco && (
              <Col md={mostrarGrauRisco ? 6 : 12}>
                <Input
                  disabled
                  model={{
                    label: capitalizeFirstLetter(
                      intl.formatMessage(
                        { id: 'matrizRisco' },
                        { risco: resources.risco }
                      )
                    ),
                    value: capitalizeFirstLetter(
                      model.getModel('descricaoMatrizRisco').value
                    ),
                    requestChange: () => {},
                  }}
                />
              </Col>
            )}
            {mostrarGrauRisco && (
              <Col md={mostrarMatrizRisco ? 6 : 12}>
                <InputGroup
                  disabled
                  model={{
                    label: capitalizeFirstLetter(
                      intl.formatMessage(
                        { id: 'grauRisco' },
                        { risco: resources.risco }
                      )
                    ),
                    value: grauRiscoDescricao,
                    requestChange: () => {},
                  }}
                  addon={
                    <LucideIcon
                      icon="CircleFilled"
                      size={16}
                      color={grauRiscoCor}
                      colorHover={grauRiscoCor}
                    />
                  }
                />
              </Col>
            )}
          </Row>
        </>
      ) : null;

    const labelDados = capitalizeFirstLetter(
      intl.formatMessage({ id: 'label.dadosDaAcao' }, { acao: resources.acao })
    );
    const labelInformacoesBasicas = capitalizeFirstLetter(
      intl.formatMessage({ id: 'label.informacoesBasicas' })
    );
    const labelCustos = capitalizeFirstLetter(
      intl.formatMessage({ id: 'custos' })
    );
    const labelChecklist = capitalizeFirstLetter(
      intl.formatMessage({ id: 'checklistTarefas' })
    );
    const labelCronograma = capitalizeFirstLetter(
      intl.formatMessage({ id: 'cronograma' })
    );
    const labelRisco = capitalizeFirstLetter(resources.risco);
    const label5W2H = capitalizeFirstLetter(
      intl.formatMessage({ id: 'label.5W2H' })
    );

    const hasSecaoCustos =
      configuracoes?.model?.utilizarInvestimentoPrevisto ||
      configuracoes?.model?.utilizarInvestimentoRealizado ||
      configuracoes?.model?.utilizarCusteioPrevisto ||
      configuracoes?.model?.utilizarCusteioRealizado ||
      hasEPModule;

    const hasSecaoChecklist =
      configuracoes?.model?.habilitarChecklistTarefas &&
      !isAcaoPreAprovacaoCadastro;

    const hasSecao5W2H =
      (configuracoes?.model?.utilizarComo && !isAcaoPreAprovacaoCadastro) ||
      (configuracoes?.model?.utilizarOnde && !isAcaoPreAprovacaoCadastro) ||
      (configuracoes?.model?.utilizarPorque && !isAcaoPreAprovacaoCadastro);

    const hasSecaoRisco = mostrarMatrizRisco || mostrarGrauRisco;

    const geralSections = [
      {
        id: AC_SEC_INFO_BASICA,
        header: labelInformacoesBasicas,
        children: secaoInfoBasica,
      },
      {
        id: AC_SEC_CRONOGRAMA,
        header: labelCronograma,
        className: 'acao-step5',
        children: secaoCronograma,
      },
    ];

    if (hasSecaoRisco) {
      geralSections.push({
        id: AC_SEC_RISCO,
        header: labelRisco,
        children: secaoRisco,
      });
    }

    if (hasSecao5W2H) {
      geralSections.push({
        id: AC_SEC_5W2H,
        header: label5W2H,
        className: 'acao-step6',
        children: secao5W2H,
      });
    }

    if (hasSecaoCustos) {
      geralSections.push({
        id: AC_SEC_CUSTOS,
        header: labelCustos,
        children: secaoCustos,
      });
    }

    if (hasSecaoChecklist) {
      const tarefasChecklist = model.getModel('tarefas').value || [];
      const tarefasConcluidas = tarefasChecklist.filter(
        (t) => t.concluida
      ).length;
      const tarefasTotal = tarefasChecklist.length;
      const checklistNavBadge = getChecklistNavBadge(
        tarefasConcluidas,
        tarefasTotal
      );

      geralSections.push({
        id: AC_SEC_CHECKLIST,
        header: labelChecklist,
        className: 'acao-step7',
        navLabel: labelChecklist,
        navBadge: checklistNavBadge,
        headerStyle: 'd-flex align-items-center flex-nowrap',
        headerActions: [
          <ModalFormCategoryBadge
            key="checklist-badge"
            badge={checklistNavBadge}
            className="ml-3"
            onClick={(e) => e.stopPropagation()}
          />,
          <span
            key="checklist-header-spacer"
            aria-hidden
            style={{ flex: 1, minWidth: 8 }}
            onClick={(e) => e.stopPropagation()}
          />,
        ],
        children: secaoChecklist,
      });
    }

    const categoryBySection = {
      [AC_SEC_INFO_BASICA]: AC_CAT_INFO_BASICA,
      [AC_SEC_CRONOGRAMA]: AC_CAT_CRONOGRAMA,
      [AC_SEC_RISCO]: AC_CAT_RISCO,
      [AC_SEC_5W2H]: AC_CAT_5W2H,
      [AC_SEC_CUSTOS]: AC_CAT_CUSTOS,
      [AC_SEC_CHECKLIST]: AC_CAT_CHECKLIST,
    };

    const geralCategories = geralSections.map((section) => ({
      id: categoryBySection[section.id],
      label: section.navLabel ?? section.header,
      sectionIds: [section.id],
      ...(section.navBadge ? { badge: section.navBadge } : {}),
    }));

    const mostrarOpcaoVincularAcao =
      isNew &&
      !parameters.isTemplateProjeto &&
      configuracoes?.model?.habilitarVinculoMaisDeUmItem &&
      !isAcaoPreAprovacaoCadastro &&
      moduloAtual &&
      moduloAtual.id !== MODULOS.MATRIZ_ORCAMENTARIA;

    const modoVincularAcao =
      mostrarOpcaoVincularAcao && model.getModel('utilizarAcaoVinculada').value;

    const vincularCategories = [
      {
        id: AC_CAT_DADOS,
        label: labelDados,
        sectionIds: [],
      },
    ];

    const tipoCadastroOptions = [
      {
        id: 'nova',
        descricao: capitalizeFirstLetter(
          intl.formatMessage(
            { id: 'cadastrarNovaAcao' },
            { acao: resources.acao }
          )
        ),
      },
      {
        id: 'vincular',
        descricao: capitalizeFirstLetter(
          intl.formatMessage(
            { id: 'label.usarAcaoDeOutroItem' },
            { acao: resources.acao }
          )
        ),
      },
    ];

    const tipoCadastroMainHeader = mostrarOpcaoVincularAcao ? (
      <TipoCadastroAcaoRow
        modoVincularAcao={modoVincularAcao}
        tipoCadastroOptions={tipoCadastroOptions}
        ehAcaoVinculada={ehAcaoVinculada}
        registroPreenchido={registroPreenchido}
        intl={intl}
        onTipoCadastroChange={this.handleTipoCadastroAcaoChange}
      />
    ) : null;

    const itemProjeto = model.getModel('item')?.value;
    const exibirAbaAlocacaoRecursos =
      !somenteLeitura &&
      hasAction &&
      !isAcaoPreAprovacaoCadastro &&
      hasEPModule &&
      itemProjeto?.tipo?.id === TIPO_ITENS.PROJETO &&
      this.state.utilizarAlocacaoRecursos &&
      model.getModel('permissions')?.value?.allowViewAlocacaoRecursos;

    return (
      <Suspense fallback={<LoadingScreen />}>
        <div className="modalFormCategoryLayoutHost">
          <div className={classes.descricaoHeaderRow}>
            <div className={classes.descricaoHeaderMain}>
              <div className={classes.descricaoHeaderContent}>
                <p
                  className={classes.descricaoHeaderTexto}
                  title={
                    resumoDescricao && resumoDescricao !== '-'
                      ? resumoDescricao
                      : undefined
                  }
                >
                  {resumoDescricao || '-'}
                </p>
                <HoverCard
                  open={this.state.resumoPopoverOpen}
                  onOpenChange={this.handleResumoPopoverOpenChange}
                  className="tw:max-h-[min(320px,50vh)] tw:max-w-90 tw:overflow-y-auto tw:bg-[rgba(55,55,55,0.95)] tw:px-3.5 tw:py-3 tw:text-white"
                  content={this.renderAcaoResumoTooltipContent({
                    intl,
                    resources,
                    resumoItem,
                    resumoDescricao,
                    resumoStatus,
                    tipoOrigemDescricao,
                    resumoInicioPrevisto,
                    resumoTerminoPrevisto,
                    farolAcao: farolAcaoResumo,
                  })}
                >
                  <span className={classes.descricaoResumoLink}>
                    {intl.formatMessage({ id: 'verResumo' })}
                  </span>
                </HoverCard>
              </div>
            </div>
          </div>
          <Tabs>
            <Tab
              key="0"
              label={capitalizeFirstLetter(
                intl.formatMessage({ id: 'label.geral' })
              )}
              navItemClass={hasAction ? undefined : 'd-none'}
            >
              <ModalFormCategoryLayout
                hideShadow
                categories={
                  modoVincularAcao ? vincularCategories : geralCategories
                }
                sections={modoVincularAcao ? [] : geralSections}
                mainHeader={tipoCadastroMainHeader}
                mainContent={
                  modoVincularAcao ? (
                    <VincularAcaoForm
                      model={model}
                      intl={intl}
                      resources={resources}
                      editarAcaoOrigem={editarAcaoOrigem}
                      ehAcaoVinculada={ehAcaoVinculada}
                      itemId={itemId}
                      onConfirmarAcaoVinculada={this.confirmarAcaoVinculada}
                    />
                  ) : null
                }
              />
            </Tab>
            {hasAction &&
              !isAcaoPreAprovacaoCadastro &&
              configuracoes?.model?.habilitarRelacionamentos && (
                <Tab
                  key="1"
                  label={capitalizeFirstLetter(
                    intl.formatMessage({ id: 'label.relacionamentos' })
                  )}
                >
                  <AcaoModalTabScroll layoutSyncKey={`rel-${acaoId}`}>
                    {ehAcaoVinculada && (
                      <p>
                        {intl.formatMessage(
                          { id: 'label.origemDaAcao' },
                          { acao: resources.acao }
                        )}
                        <a
                          style={{ color: '#005ce6' }}
                          onClick={this.clickItemAcaoOrigem.bind(
                            this,
                            model.getModel('itemAcaoOrigem').value
                          )}
                        >
                          {model &&
                            model.getModel('itemAcaoOrigem') &&
                            model.getModel('itemAcaoOrigem').value &&
                            model.getModel('itemAcaoOrigem').value.nome}
                        </a>
                      </p>
                    )}
                    {model &&
                      model.getModel('ehAcaoVinculada') &&
                      !model.getModel('ehAcaoVinculada').value && (
                        <TabelaRelacionamento
                          model={model.getModel('itensVinculados')}
                          allowNew={
                            !somenteLeitura &&
                            model.getModel('permissions') &&
                            model.getModel('permissions').value != null
                              ? model.getModel('permissions').value.allowEdit
                              : false
                          }
                          disabled={
                            somenteLeitura ||
                            (model.getModel('permissions') &&
                            model.getModel('permissions').value != null
                              ? !model.getModel('permissions').value.allowEdit
                              : true)
                          }
                          closeModal={this.props.handleCloseEdit}
                          parameters={{ itemIdIgnorar: itemId }}
                        ></TabelaRelacionamento>
                      )}
                  </AcaoModalTabScroll>
                </Tab>
              )}
            {hasAction &&
              !isAcaoPreAprovacaoCadastro &&
              configuracoes?.model?.visualizarPercentualAvancoFisico &&
              hasEPModule && (
                <Tab
                  key="2"
                  label={capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'percentualAvancoFisicoAcao' },
                      { acao: resources.acao }
                    )
                  )}
                >
                  <AcaoModalTabScroll layoutSyncKey={`paf-${acaoId}`}>
                    <PercentualAvancoFisicoList
                      acaoId={acaoId}
                      configuration={configuracoes?.model}
                    />
                  </AcaoModalTabScroll>
                </Tab>
              )}
            {/* Desenvolvido para licitação, será comentado para, caso necessário, ser usado novamente
             {utilizarDetalhamentoFinanceiro && hasEPModule && (
              <Row>
                <Col md={12}>
                  <Panel
                    open={false}
                    header={intl.formatMessage({
                      id: 'detalhamentoFinanceiro',
                    })}
                  >
                    <DetalhamentoFinanceiro acaoId={acaoId} />
                  </Panel>
                </Col>
              </Row>
            )} */}
            {hasAction &&
              !isAcaoPreAprovacaoCadastro &&
              permissoesAcaoValor.allowView &&
              !somenteLeitura &&
              configuracoes?.model?.utilizarGanhosPorAcao &&
              moduloAtual &&
              (moduloAtual.id === MODULOS.GESTAO_ESTRATEGICA ||
                moduloAtual.id === MODULOS.MATRIZ_ORCAMENTARIA ||
                moduloAtual.id === MODULOS.ESCRITORIO_PROJETOS) && (
                <Tab
                  key="4"
                  label={capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'ganhosPorAcao' },
                      { acao: resources.acao }
                    )
                  )}
                >
                  <AcaoModalTabScroll layoutSyncKey={acaoId}>
                    <GanhosPorAcaoEdit acaoId={acaoId} />
                  </AcaoModalTabScroll>
                </Tab>
              )}
            {exibirAbaAlocacaoRecursos && (
              <Tab
                key="alocacao-recursos"
                label={capitalizeFirstLetter(
                  intl.formatMessage({ id: 'alocacaoRecursos' })
                )}
              >
                <AcaoModalTabScroll layoutSyncKey={`aloc-${acaoId}`}>
                  <AlocacaoRecursos
                    embedded
                    acaoIdProp={acaoId}
                    acaoDescricaoProp={model.getModel('descricao')?.value}
                    registerSaveApi={this.registerAlocacaoSaveApi}
                  />
                </AcaoModalTabScroll>
              </Tab>
            )}
            {hasAction && (
              <Tab
                key="5"
                label={capitalizeFirstLetter(
                  intl.formatMessage({ id: 'label.historico' })
                )}
              >
                <AcaoModalTabScroll
                  layoutSyncKey={this.state.historicoRefreshToken}
                >
                  <Historico
                    url={`/Acao/ObterHistorico`}
                    id={acaoId}
                    refreshToken={this.state.historicoRefreshToken}
                  />
                </AcaoModalTabScroll>
              </Tab>
            )}
            {hasAction && hasSecaoChecklist && (
              <Tab
                key="6"
                label={capitalizeFirstLetter(
                  intl.formatMessage({ id: 'label.historicoTarefa' })
                )}
              >
                <AcaoModalTabScroll
                  layoutSyncKey={`histtarefa-${this.state.historicoRefreshToken}`}
                >
                  <HistoricoAcaoTarefa
                    acaoId={acaoId}
                    refreshToken={this.state.historicoRefreshToken}
                  />
                </AcaoModalTabScroll>
              </Tab>
            )}
          </Tabs>
        </div>
      </Suspense>
    );
  }
}

@autobind
class AcaoEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = { refreshId: 0 };
    this.formEditRef = React.createRef();
    if (this.props.item && this.props.item.id)
      this.ehAcaoVinculada(this.props.item.id);
  }

  async ehAcaoVinculada(acaoId) {
    const { data } = await http.post(`/Acao/EhAcaoVinculada`, { acaoId });
    this.setState({ ehAcaoVinculada: data });
  }

  handleConfirmeBeforeSave(model, handleSave, intl, fechar) {
    if (this.props.disabled || this.props.disabledEdit) return;
    const formEdit = this.formEditRef.current;
    const proceed = () => handleSave(fechar);
    if (!formEdit || typeof formEdit.saveAlocacaoIfDirty !== 'function') {
      proceed();
      return;
    }
    formEdit
      .saveAlocacaoIfDirty()
      .then(proceed)
      .catch((error) => errorHandler(error));
  }

  handleDelete(item) {
    ContentManager.addContent(
      <ValidacaoRestricao
        url="/Acao/ValidarRestricoes"
        urlExclusao="/Acao/Remove"
        item={item}
        onClose={this.handleDeleteClickConfirm.bind(this)}
      />
    );
  }

  handleDeleteClickConfirm(excluido) {
    if (excluido) {
      ContentManager.addContent(
        <Alert
          title={this.props.intl.formatMessage({ id: 'sucesso' })}
          message={this.props.intl.formatMessage({
            id: 'label.registroExcluidoComSucesso',
          })}
        />
      );
    }
  }

  handleCallBack() {
    const { ganhosPorAcao } = this.props;
    const acaoId = this.props.item ? this.props.item.id : 0;

    if (
      acaoId != 0 &&
      ganhosPorAcao?.valoresGanhosPorAcao &&
      ganhosPorAcao.valoresGanhosPorAcao.length > 0
    ) {
      this.setState({
        isLoading: true,
      });

      http
        .post(`/AcaoValor/SalvarValores`, {
          valores: ganhosPorAcao.valoresGanhosPorAcao,
          acaoId: acaoId,
        })
        .then((response) => {
          this.setState({
            ...this.state,
            isLoading: false,
            valores: response.data.valores,
          });
        });
    }

    // if (ganhosPorAcao && ganhosPorAcao.valoresGanhosPorAcao){
    //   this.props.setGanhosPorAcao(ganhosPorAcao.valoresGanhosPorAcao, acaoId).then();
    // }
  }

  handleRefresh() {
    this.setState({ refreshId: this.state.refreshId + 1 });
  }

  afterSave(item) {
    const formEdit = this.formEditRef.current;
    if (formEdit) {
      formEdit.setState((prev) => ({
        historicoRefreshToken: (prev.historicoRefreshToken || 0) + 1,
      }));
    }

    this.props.afterSave && this.props.afterSave(item);
  }

  render() {
    const { endpoint = '/Acao', handleCallBack, resources } = this.props || {};
    const somenteLeitura =
      this.props.disabled === true || this.props.disabledEdit === true;

    const parameters = {
      ...this.props.parameters,
      acaoId: this.props.item && this.props.item.id,
    };

    return (
      <Edit
        {...this.props}
        loadingContainerClassName="tw:flex tw:min-h-0 tw:flex-1 tw:flex-col"
        respeitarAltura
        id="editAcao"
        url={endpoint}
        validateAlterModel={
          !somenteLeitura && (this.props.validateAlterModel ?? true)
        }
        title={
          somenteLeitura
            ? capitalizeFirstLetter(resources.acao)
            : this.props.item && this.props.item.id
            ? `${capitalizeFirstLetter(resources.editar)} ${resources.acao}`
            : `${capitalizeFirstLetter(
                this.props.intl.formatMessage(
                  { id: 'criarAcao' },
                  { acao: resources.acao }
                )
              )}`
        }
        styleTitle={{
          color: '#09090B',
          fontSize: 14,
          fontWeight: 500,
          margin: 0,
        }}
        styleFooter={{
          borderRadius: '0 0 16px 16px',
          borderTop: '1px solid #E4E4E7',
          background: '#FAFAFA',
          padding: '16px',
        }}
        formComponent={FormEdit}
        formComponentRef={this.formEditRef}
        handleConfirmeBeforeSave={this.handleConfirmeBeforeSave}
        messageSave="label.registroSalvoComSucesso"
        saveLabelId="label.salvarAcao"
        saveLabelValues={{ acao: resources.acao }}
        showSaveClose={false}
        close={false}
        showDelete={!somenteLeitura && (this.props.showDelete ?? true)}
        showDeleteInFooter={!somenteLeitura}
        showIconDelete={!somenteLeitura}
        showExport={this.props.showExport ?? true}
        refreshId={this.state.refreshId}
        handleRefresh={this.handleRefresh}
        width="71rem"
        height="48rem"
        minWidth="50%"
        minHeight="90%"
        maxHeight="100%"
        resources={this.props.resources}
        schema={schema}
        onDeleting={
          this.props.onDeleting ||
          (this.state.ehAcaoVinculada && this.handleDelete)
        }
        handleCallBack={handleCallBack ? handleCallBack : this.handleCallBack}
        urlExport={`/Acao/ExportarAcao`}
        parameters={parameters}
        afterSave={this.afterSave}
      />
    );
  }
}

function AcaoModalTabScroll({ children, layoutSyncKey = 0 }) {
  const mainRef = useRef(null);
  useCollapsesScrollHeight(mainRef, [layoutSyncKey]);

  return (
    <div className="modalFormCategoryLayoutHost__tabBody">
      <div ref={mainRef} className="modalFormCategoryLayoutHost__tabMain">
        {children}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    moduloAtual: state.user.moduloAtual,
    user: state.user,
    ganhosPorAcao: state.ganhosPorAcao,
    tiposAnexos: state.user.tiposAnexos,
    modules: state.user.licenca.modulos,
  };
}

export default injectIntl(
  connect(mapStateToProps, { setGanhosPorAcao })(AcaoEdit)
);
